/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import './Bebidas.css';
import CardPratos from '../CardPratos/CardPratos';
import { getFirestore, getDocs, collection } from 'firebase/firestore';
import { fireBaseApp } from '../../App';

const Bebidas = () => {
  const [pratos, setPratos] = useState([]);

  const db = getFirestore(fireBaseApp);
  const cardapioRef = collection(db, 'Bebidas');

  const getPratos = async () => {
    const data = await getDocs(cardapioRef);
    const bebidas = data.docs.map(doc => doc.data());
    setPratos(bebidas);
  };

  useEffect(() => {
    getPratos();
  }, []);

  return (
    <section id="bebidas">
      <h2>BEBIDAS</h2>
      <ul>
        {pratos.map((prato, index) => (
          <CardPratos prato={prato} key={`@bebidas-${index}`}/>
        ))}
      </ul>
    </section>
  );
};

export default Bebidas;
